module.exports = __webpack_public_path__ + "img/bind-success.0fa2dd17.png";